












































































































import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'Home',

  async created() {

    // implement security (kick users to form, admins to dashboard)

    try {

      var getCookie = (cName:any) => {

        const name = cName + "=";

        const cDecoded = decodeURIComponent(document.cookie);

        const cArr = cDecoded.split("; ");

        let value = '';

        cArr.forEach(val => {

          if(val.indexOf(name) === 0){

            value = val.substring(name.length);

          }

        })

        return value;
      }

      var setCookie = (cName: any, cValue:any, expDays:any) => {

        let date = new Date();

        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));

        const expires = "expires=" + date.toUTCString();

        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";

      }

      var showPopupCookie = getCookie('cookiesconsent_showPopup');

      if (showPopupCookie == '') setCookie('cookiesconsent_showPopup', false, 90);

      this.$store.dispatch('updateShowCookieBanner', false);

      // get the user profile

      let obj = await axios.get('accounts/GetUserProfile');

      this.$store.dispatch('updateUserProfile', obj.data);

      if (obj.data.role == 'User') {

        this.$router.push('/Dashboard');

      }
      else if (obj.data.role == 'Admin') {

        this.$router.push('/Admin/Dashboard');

      }
    }
    catch
    {
      // the user is not signed in (do nothing)
    }

  }

})

